import React, { useState, useRef, useEffect } from 'react';
import { 
  EyeIcon, 
  PencilIcon, 
  TrashIcon, 
  DocumentDuplicateIcon,
  PaperAirplaneIcon,
  EllipsisVerticalIcon
} from '@heroicons/react/24/outline';

// PROMPT-163: Template Quick Actions Menu
const TemplateQuickActions = ({ 
  template, 
  onView, 
  onEdit, 
  onDelete, 
  onDuplicate, 
  onSendTest,
  canEdit,
  canDelete,
  canSendTest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleAction = (action) => {
    setIsOpen(false);
    action();
  };

  return (
    <div className="relative" ref={menuRef}>
      {/* Menu Button */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
        title="More actions"
      >
        <EllipsisVerticalIcon className="h-5 w-5" />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 z-50 mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1">
          {/* View Template */}
          <button
            type="button"
            onClick={() => handleAction(() => onView(template))}
            className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <EyeIcon className="h-4 w-4 mr-3 text-gray-400" />
            View Details
          </button>

          {/* Edit Template */}
          {canEdit && (
            <button
              type="button"
              onClick={() => handleAction(() => onEdit(template))}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <PencilIcon className="h-4 w-4 mr-3 text-gray-400" />
              Edit Template
            </button>
          )}

          {/* Duplicate Template */}
          {canEdit && (
            <button
              type="button"
              onClick={() => handleAction(() => onDuplicate(template))}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <DocumentDuplicateIcon className="h-4 w-4 mr-3 text-gray-400" />
              Duplicate
            </button>
          )}

          {/* Send Test SMS */}
          {canSendTest && (
            <button
              type="button"
              onClick={() => handleAction(() => onSendTest(template))}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <PaperAirplaneIcon className="h-4 w-4 mr-3 text-gray-400" />
              Send Test SMS
            </button>
          )}

          {/* Delete Template */}
          {canDelete && (
            <>
              <div className="border-t border-gray-200 my-1"></div>
              <button
                type="button"
                onClick={() => handleAction(() => onDelete(template))}
                className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
              >
                <TrashIcon className="h-4 w-4 mr-3 text-red-400" />
                Delete Template
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TemplateQuickActions;
